'use client';

import { ThemeProvider } from "@mui/material/styles";
import { createTheme } from "@mui/material/styles";
import { themeConfig } from "@/theme";

interface ThemeWrapperProps {
  locale: string;
  children: React.ReactNode;
}

export default function ThemeWrapper({ locale, children }: ThemeWrapperProps) {
  const direction = locale === "he" ? "rtl" : "ltr";
  const theme = createTheme({ ...themeConfig, direction });

  return <ThemeProvider theme={theme}>{children}</ThemeProvider>;
}
